// extracted by mini-css-extract-plugin
module.exports = {"bottomDetailsColumn":"BottomDetailsColumn_bottomDetailsColumn__dVDA5"};